import Header from './components/Header';
import Hero from './components/Hero';
import AboutAppSection from './components/AboutAppSection';
import FaqContactSection from './components/FaqContactSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import IndexCardsSection from './components/IndexCardsSection';
import FeaturesUpdatesSection from './components/FeaturesUpdatesSection';
import CarouselTopicsSection from './components/CarouselTopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <AboutAppSection />
        <FaqContactSection />
        <MediaSection />
        <CommentsSection />
        <RankingSection />
        <IndexCardsSection />
        <FeaturesUpdatesSection />
        <CarouselTopicsSection />
      </main>
      <Footer />
    </div>
  );
}